import Hub from "./hub";

export default new Hub();
